// extracted by mini-css-extract-plugin
export default {"item":"ltBnVUk83woVWOfEoAdy","dropdown":"N96hm3mAx6AmDs0J6qo2"};